<template>
  <div class="pc20191021">
    <div class="topnav-warp">
      <div class="topnav">
        <img class="logo" src="~_img/logo2.png" alt="" />
        <div class="tel-warp">
          <div class="learn-course" @click="popupFormShow">了解课程</div>
          <img class="tel" src="~_img/topnav/telphone2.png" alt="" />
          <div class="telphone" @click="clickTel">400-186-5291</div>
        </div>
      </div>
    </div>
    <div class="banner" id="stayBanner">
      <mt-swipe :auto="4000" :show-indicators="false">
        <mt-swipe-item>
          <div
            class="bannerbg"
            :style="{ backgroundImage: 'url(' + bannerList[0] + ')' }"
          ></div>
        </mt-swipe-item>
        <mt-swipe-item>
          <div
            class="bannerbg"
            :style="{ backgroundImage: 'url(' + bannerList[1] + ')' }"
          ></div>
        </mt-swipe-item>
        <mt-swipe-item>
          <div
            class="bannerbg"
            :style="{ backgroundImage: 'url(' + bannerList[2] + ')' }"
          ></div>
        </mt-swipe-item>
        <mt-swipe-item>
          <div
            class="bannerbg"
            :style="{ backgroundImage: 'url(' + bannerList[3] + ')' }"
          ></div>
        </mt-swipe-item>
      </mt-swipe>
      <bannerform></bannerform>
    </div>
    <timerBar></timerBar>
    <course></course>
    <div class="moudle-warp moudle1-warp" id="stayOneToOne">
      <div class="moudle moudle1">
        <p class="moudle-title"><span>“1对1”</span>专属学习体验</p>
        <div class="img-warp">
          <div class="img-item">
            <img src="~_img/coursecardimg/moudle1-1.png" alt="">
            <div class="img-hover">诊断学习习惯及能力分析阻碍提升的原因</div>
          </div>
          <div class="img-item">
            <img src="~_img/coursecardimg/moudle1-2.png" alt="">
            <div class="img-hover">个性定制教学内容<br>弹性调整课程难度</div>
          </div>
          <div class="img-item">
            <img src="~_img/coursecardimg/moudle1-3.png" alt="">
            <div class="img-hover img-hover3">大数据筛选精英师资<br>匹配最合适的教师</div>
            </div>
          <div class="img-item">
            <img src="~_img/coursecardimg/moudle1-4.png" alt="">
            <div class="img-hover img-hover4">课前灵活调整教案<br>课中针对性查缺补漏<br>课后随时答疑解惑</div>
          </div>
        </div>
        <div class="text-warp">
          <span>个性学情诊断</span>
          <span>定制提分方案</span>
          <span>匹配优质师资</span>
          <span>专属辅导伴学</span>
        </div>
      </div>
    </div>
    <div class="moudle-warp moudle2-warp" id="stayGoodTeacher">
      <div class="moudle moudle2">
        <p class="moudle-title"><span>“好老师”</span>层层优选，教学有保障</p>
        <div class="moudle2-content-warp">
          <div class="moudle2-content">
            <div :class="(key != lottieItem)?'circle':'circle circle-hover'" v-for="(item ,key) in 4" :key="key" @mouseenter="lottieShow(key)" @mouseleave="lottieHidden" >
              <div class="circle-lottie" v-if="key == lottieItem">
                <lottie :options="defaultOptions" :height='40' :width='40' v-on:animCreated="handleAnimation" />
              </div>
            </div>
            <div class="text text1" @mouseenter="lottieShow(0)" @mouseleave="lottieHidden">
              <span class="title">4轮</span><span class="sub-title">筛选</span>
              <div class="sub-des">严选 “三强” <span v-html="'&nbsp;&nbsp;'"></span> “三优”<br> 高学历<span v-html="'&nbsp;&nbsp;'"></span>高水平</div>
            </div>
            <div class="text text2" @mouseenter="lottieShow(1)" @mouseleave="lottieHidden">
              <span class="title">5轮</span><span class="sub-title">培训</span>
              <div class="sub-des">专业功底强<span v-html="'&nbsp;&nbsp;'"></span>综合高能力</div>
            </div>
            <div class="text text3" @mouseenter="lottieShow(2)" @mouseleave="lottieHidden">
              <span class="title">6轮</span><span class="sub-title">筛选</span>
              <div class="sub-des">细致教学<span v-html="'&nbsp;&nbsp;'"></span>微考核</div>
            </div>
            <div class="text text4" @mouseenter="lottieShow(3)" @mouseleave="lottieHidden">
              <span class="title">0.3%</span><span class="sub-title">筛选</span>
              <div class="sub-des">低于0.3%录取<span v-html="'&nbsp;&nbsp;'"></span>高配<span v-html="'&nbsp;&nbsp;'"></span>高质<span v-html="'&nbsp;&nbsp;'"></span>好老师</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="moudle-warp moudle3-warp" id="stayGoodClass">
      <div class="moudle moudle3">
        <p class="moudle-title"><span>“好课堂”</span>让进步看得见</p>
        <div class="video-content">
          <video width="617" height="402" controls autoplay v-if="isVideoShow" controlsList="nodownload">
              <source src="https://k12-web.oss-cn-zhangjiakou.aliyuncs.com/static/dev/www/good_class.mp4" type="video/mp4">
          </video>
          <img src="~_img/coursecardimg/videoposter.png" alt="" v-if="!isVideoShow">
          <div class="video-icon" @click="videoShow" v-if="!isVideoShow"></div>
        </div>
        <div class="video-des">
          <div class="des-item">
            <img src="~_img/coursecardimg/number1.png" alt="">
            <div class="des">
              <p class="des-title">愿表达</p>
              <p class="des-sub-title">鼓励孩子主动提问，并复述讲题</p>
              <p class="des-sub-title">培养开口表达，强化记忆的好习惯</p>
            </div>
          </div>
          <div class="des-item">
            <img src="~_img/coursecardimg/number2.png" alt="">
            <div class="des">
              <p class="des-title">勤动笔</p>
              <p class="des-sub-title">实时跟盯孩子笔记及答题过程</p>
              <p class="des-sub-title">培养动笔实践及时纠错的好习惯</p>
            </div>
          </div>
          <div class="des-item">
            <img src="~_img/coursecardimg/number3.png" alt="">
            <div class="des">
              <p class="des-title">善总结</p>
              <p class="des-sub-title">引导孩子自主绘制思维导图</p>
              <p class="des-sub-title">培养梳理归纳，勤于总结的好习惯</p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="moudle-warp moudle4-warp" id="stayGoodIntroduction">
      <div class="moudle moudle4">
          <p class="moudle-title"><span>“好教学”</span>100%关注，更贴合学情</p>
          <img src="http://img2.xes1v1.com/pclp/online/moudle4.png" alt="">
      </div>
    </div>
    <div class="moudle-warp moudle5-warp">
      <div class="moudle moudle5">
          <p class="moudle-title">我们用心承诺，为您和孩子提供保障</p>
          <div class="moudle5-item-warp">
            <div class="moudle5-item">
              <img src="~_img/coursecardimg/moudle5-icon1.png" alt="">
              <p>上市机构，安全可靠</p>
            </div>
            <div class="moudle5-item">
              <img src="~_img/coursecardimg/moudle5-icon2.png" alt="">
              <p>随时退费，保障权益</p>
            </div>
            <div class="moudle5-item">
              <img src="~_img/coursecardimg/moudle5-icon3.png" alt="">
              <p>全程伴学，专属答疑</p>
            </div>
            <div class="moudle5-item">
              <img src="~_img/coursecardimg/moudle5-icon4.png" alt="">
              <p>旁听监课，家长放心</p>
            </div>
          </div>
          <p class="moudle7-bottom1">Copyright<span v-html="'&nbsp;&nbsp;'"></span>2019 © 北京学而思网络科技有限公司 京ICP备09042963号-34 京公网安备11010802029670号</p>
          <p class="moudle7-bottom2"><img src="~_img/coursecardimg/bottom-tel.png" alt=""> 400-186-5291<span v-html="'&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;'"></span>周一至周日 8:00-21:00</p>
      </div>
    </div>
    <footerform></footerform>
    <asidefloat></asidefloat>
    <popupform :isPopupFormShow="isPopupFormShow" @popupFormClose="popupFormClose" :origin="origin"></popupform>
  </div>
</template>

<script>
import footerform from "./components/footerform";
import bannerform from "./components/bannerform";
import asidefloat from "./components/asidefloat";
import timerBar from "@/components/timerBar";
import course from "./components/course";
import popupform from "@/components/popupform";
import { Swipe, SwipeItem } from "mint-ui";
import {saTrack} from '@xes/dh-sensor';
import Lottie from 'vue-lottie'
import * as animationData from "./json/circle2.json"

export default {
  name: "pc20191021",
  components: {
    [Swipe.name]: Swipe,
    [SwipeItem.name]: SwipeItem,
    'Lottie':Lottie,
    footerform,
    bannerform,
    asidefloat,
    timerBar,
    course,
    popupform,
  },
  data() {
    return {
      origin:"",
      dataList: [],
      imgUrl: "",
      isPopupFormShow: false,
      isVideoShow: false,
      defaultOptions:{animationData: animationData.default},
      animationSpeed: 1,
      lottieItem: 5,
      bannerList: [
        "//img3.xes1v1.com/pclp/online/bg1.png",
        "//img3.xes1v1.com/pclp/online/bg2.png",
        "//img3.xes1v1.com/pclp/online/bg5.png",
        "//img3.xes1v1.com/pclp/online/bg4.png",
      ],
    };
  },
  mounted() {

  },
  methods: {
    handleAnimation(anim) {
      this.anim = anim
    },
    popupFormShow() {
      saTrack("topCourseIntro");
      this.origin = "了解课程"
      this.isPopupFormShow = true;
    },
    popupFormClose(data) {
      this.isPopupFormShow = data;
    },
    lottieShow(item) {
      console.log(item,"111111")
      this.lottieItem = item;
    },
    lottieHidden() {
      this.lottieItem = 5;
    },
    clickTel() {
      saTrack("top400Chat");
    },
    videoShow () {
      saTrack("clickPlayVideo",{str_param1:"https://k12-web.oss-cn-zhangjiakou.aliyuncs.com/static/dev/www/good_class.mp4"});
      this.isVideoShow = true;
    }
  },
};
</script>

<style lang="scss" scoped>
.pc20191021 {
  background: #f9f9f9;
  .topnav-warp {
    width: 100%;
    background: #fff;
    .topnav {
      width: 1200px;
      height: 81px;
      margin: 0 auto;
      .logo {
        height: 29px;
        margin-top: 28px;
      }
      .tel-warp {
        float: right;
        display: flex;
      }
      .learn-course {
        font-size: 18px;
        color: #333333;
        line-height: 17px;
        width: 72px;
        height: 17px;
        position: relative;
        margin-top: 34px;
        margin-right: 50px;
        margin-bottom: 30px;
      }
      .learn-course:hover {
        cursor: pointer;
      }
      .learn-course:after {
        content: "";
        width: 72px;
        height: 2px;
        background: #df2727;
        border-radius: 1px;
        position: absolute;
        bottom: -22px;
        left: 0;
      }
      .tel {
        float: left;
        margin: 33px 4px 29px 0;
      }
      .telphone {
        margin-top: 36px;
        box-sizing: border-box;
        height: 16px;
        line-height: 16px;
        font-size: 18px;
        color: rgba(102, 102, 102, 1);
      }
    }
  }
  .banner {
    width: 100%;
    min-width: 1200px;
    height: 500px;
    position: relative;
    .bannerbg {
      background: #DF2727;
      background-repeat: no-repeat;
      background-position: center;
      width: 100%;
      height: 500px;
    }
  }
  .moudle-warp {
    width: 100%;
    background: #F6F6F6;
    min-width: 1200px;
    .moudle {
      padding-top: 100px;
      width: 1200px;
      margin: 0 auto;
      .moudle-title {
        font-size: 36px;
        font-weight: 600;
        color: #000000;
        line-height: 36px;
        text-align: center;
        span {
          color: #E61623;
        }
      }
    }
  }
  .moudle1-warp {
    height: 542px;
    .moudle1 {
      box-sizing: border-box;
      p{
        margin-bottom: 63px;
        span {
          color: #E61623;
        }
      }
      .img-warp {
        width: 1233px;
        margin: 0 auto;
        position: relative;
        left: -18px;
        .img-item {
          display: inline-block;
          position: relative;
          .img-hover {
            display: none;
            width: 262px;
            height: 190px;
            background: rgba(230, 22, 35, .8);
            box-sizing: border-box;
            padding: 71px 49px;
            font-size: 18px;
            font-family: FZLanTingHeiS-DB-GB;
            font-weight: 400;
            color: #FFFFFF;
            line-height: 24px;
            position: absolute;
            top: 17px;
            left: 17px;
            text-align: center;
          }
          .img-hover3 {
            width: 280px;
          }
          .img-hover4 {
            width: 280px;
            padding: 59px 49px;
          }
        }
        img {
          margin-right: 18px;
        }
        .img-item:last-child img{
          margin-right: 0;
        }
        .img-item:hover {
          .img-hover {
            display: block;
          }
        }
      }
      .text-warp {
        width: 1233px;
        margin: 0 auto;
        position: relative;
        left: -18px;
        span {
          display: inline-block;
          width: 294px;
          text-align: center;
          margin-right: 18px;
          margin-top: 13px;
          font-size: 22px;
          font-weight: 500;
          color: #000000;
          line-height: 22px;
        }
        span:last-child{
          margin-right: 0;
        }
      }
    }
  }
  .moudle2-warp {
    height: 445px;
    background: #ffffff;
    width: 100%;
    .moudle2 {
      box-sizing: border-box;
      background-image: url("~_img/coursecardimg/moudle2bg.png");
      background-repeat: no-repeat;
      background-position: center;
      width: 100%;
      min-width: 1200px;
      .moudle2-content-warp {
        width: 100%;
        margin-top: 93px;
        border-top: 1px solid #EEEEEE;
        .moudle2-content {
          width: 1200px;
          margin: 0 auto;
          height: 214px;
          .circle {
            width: 34px;
            height: 34px;
            background-image: url("~_img/coursecardimg/circle1.png");
            background-repeat: no-repeat;
            background-size: 22px 22px;
            background-position: center;
            margin-right: 215px;
            display: inline-block;
            margin-top: -17px;
            margin-bottom: 20px;
            .circle-lottie {
              width: 40px;
              height: 40px;
              position: absolute;
              div {
                position: relative;
                top: -3px;
                left: -3px;
              }
            }
          }
          .circle-hover {
            background-image: none;
          }
          .circle:first-child {
            margin-left: 168px;
          }
          .text {
            float: left;
            height: 100px;
            .title {
              font-size: 36px;
              font-weight: 600;
              color: #000000;
              line-height: 34px;
              margin-right: 10px;
            }
            .sub-title {
              font-size: 20px;
              font-weight: 400;
              color: #666666;
            }
            .sub-des {
              margin-top: 19px;
              font-size: 14px;
              font-weight: 400;
              color: #7C7C7C;
              line-height: 19px;
            }
          }
          .text1 {
            width: 140px;
            margin-left: 155px;
          }
          .text2 {
            width: 155px;
            margin-left: 113px;
          }
          .text3 {
            width: 113px;
            margin-left: 95px;
          }
          .text4 {
            width: 215px;
            margin-left: 124px;
          }
        }
      }
    }
  }
  .moudle3-warp {
    height: 694px;
    .moudle3 {
      box-sizing: border-box;
      width: 1200px;
      .video-content {
        width: 611px;
        height: 396px;
        margin-top: 80px;
        margin-left: 119px;
        margin-right: 74px;
        float: left;
        overflow: hidden;
        position: relative;
        video {
          margin-top: -3px;
          margin-left: -2px;
        }
        img {
          width: 611px;
          height: 396px;
          position: absolute;
          top: 0;
          left: 0;
        }
        .video-icon {
          background: url("~_img/coursecardimg/video-icon.png") no-repeat;
          width: 84px;
          height: 84px;
          position: absolute;
          top: 156px;
          left: 264px;
        }
      }
      .video-content:hover {
        cursor: pointer;
        .video-icon {
          background: url("~_img/coursecardimg/video-icon2.png") no-repeat;
        }
      }
      .video-des {
        width: 277px;
        height: 396px;
        margin-top: 85px;
        float: left;
        .des-item {
          margin-bottom: 52px;
          img {
            width: 27px;
            height: 25px;
            margin-bottom: 62px;
            margin-right: 14px;
          }
          .des {
            width: 230px;
            height: 90px;
            display: inline-block;
            border-left: 1px solid #E5E5E5;
            padding-left: 14px;
            box-sizing: border-box;
            .des-title {
              font-size: 26px;
              font-weight: 600;
              color: #000000;
              line-height: 26px;
              border-bottom: 4px solid #BBBBBB;
              padding-bottom: 7px;
            }
            .des-sub-title {
              font-size: 14px;
              font-weight: 400;
              color: #333333;
              line-height: 30px;
            }
          }
        }
      }
    }
  }
  .moudle4-warp {
    height: 605px;
    background: #FFF;
    .moudle4 {
      box-sizing: border-box;
      width: 1200px;
      img {
        width: 1248px;
        height: 353px;
        margin-left: -27px;
        margin-top: 33px;
      }
    }
  }
  .moudle5-warp {
    height: 579px;
    .moudle5 {
      box-sizing: border-box;
      width: 1200px;
      .moudle-title {
        font-size: 30px;
        line-height: 30px;
        margin-bottom: 75px;
      }
      .moudle5-item-warp {
        padding: 0 40px;
        width: 100%;
        padding-bottom: 59px;
        border-bottom: 1px solid #DCDCDC;
        .moudle5-item {
          width: 279px;
          height: 79px;
          display: inline-block;
          border-right: 1px solid #C0C0C0;
          img {
            display: block;
            margin: 5px auto 20px;
          }
          p {
            font-size: 16px;
            font-weight: 400;
            color: #333333;
            line-height: 17px;
            text-align: center;
          }
        }
        .moudle5-item:last-child {
          img{
            width: 32px;
            height: 46px;
          }
        }
      }
      .moudle7-bottom1, .moudle7-bottom2{
        font-size: 14px;
        font-weight: 400;
        color: #333333;
        line-height: 25px;
        text-align: center;
      }
      .moudle7-bottom1 {
        margin-top: 51px;
      }
      .moudle7-bottom2 {
        margin-top: 10px;
        img {
          position: relative;
          top: 1px;
        }
      }
    }
  }
}
</style>